export default __webpack_public_path__ + "static/media/head04_th_pc@2x.cd819613.png";